import { AxiosPromise } from 'axios';

import { ApiService } from 'app/services/api.service';
import { formConfigVersions } from 'app/services/env.service';
import { OfferFormConfigInterface } from 'app/shared/interfaces/OfferFormConfig.interface';
import { FormConfig } from 'app/shared/interfaces/FormConfig.interface';

const formConfigVersionSegment = (version?: string): string =>
  version ?? 'current';

export const FormsConfigurationsService = {
  url: 'form-configurations',

  getOfferFormsConfig(
    shouldGetMotorConfig?: boolean
  ): AxiosPromise<OfferFormConfigInterface> {
    const params = {
      ...(shouldGetMotorConfig && { vehicleKind: 'MOTOR' }),
    };

    return ApiService.get(
      `${this.url}/offer-forms/${formConfigVersionSegment(
        formConfigVersions.carOffer
      )}`,
      { params }
    );
  },

  getCheckoutFormConfig(
    insurer: string,
    insuranceType: string,
    resultId: string,
    shouldGetMotorConfig?: boolean
  ): AxiosPromise<FormConfig> {
    const params = {
      insurer,
      insuranceType,
      resultId,
      ...(shouldGetMotorConfig && { vehicleKind: 'MOTOR' }),
    };

    return ApiService.get(
      `${this.url}/checkout-forms/${formConfigVersionSegment(
        formConfigVersions.carCheckout
      )}`,
      {
        params,
      }
    );
  },

  getCheckoutPaymentFormConfig(
    insurer: string,
    insuranceType: string,
    resultId: string
  ): AxiosPromise<FormConfig> {
    return ApiService.get(
      `${this.url}/payment-forms/${formConfigVersionSegment(
        formConfigVersions.carPayment
      )}`,
      {
        params: {
          insurer,
          insuranceType,
          resultId,
        },
      }
    );
  },

  getRegisterFormConfig(): AxiosPromise<FormConfig> {
    return ApiService.get(
      `${this.url}/register-forms/${formConfigVersionSegment(
        formConfigVersions.register
      )}`
    );
  },

  getRecoveryRequestFormConfig(): AxiosPromise<FormConfig> {
    return ApiService.get(
      `${this.url}/recovery-request-forms/${formConfigVersionSegment(
        formConfigVersions.recoveryRequest
      )}`
    );
  },

  getCallbackFormConfig(): AxiosPromise<FormConfig> {
    return ApiService.get(
      `${this.url}/callback-forms/${formConfigVersionSegment(
        formConfigVersions.callback
      )}`
    );
  },

  getCheckoutPaymentAlertFormConfig(): AxiosPromise<FormConfig> {
    return ApiService.get(
      `${this.url}/suspended-policy-forms/${formConfigVersionSegment(
        formConfigVersions.carSuspendedPolicy
      )}`
    );
  },

  getQuotationForm(shouldGetMotorConfig?: boolean): AxiosPromise<FormConfig> {
    const params = {
      ...(shouldGetMotorConfig && { vehicleKind: 'MOTOR' }),
    };

    return ApiService.get(
      `${this.url}/quotation-forms/${formConfigVersionSegment(
        formConfigVersions.carQuotation
      )}`,
      { params }
    );
  },

  getCompleteDataForm(
    shouldGetMotorConfig?: boolean
  ): AxiosPromise<FormConfig> {
    const params = {
      ...(shouldGetMotorConfig && { vehicleKind: 'MOTOR' }),
    };

    return ApiService.get(
      `${this.url}/complete-data-forms/${formConfigVersionSegment(
        formConfigVersions.carCompleteData
      )}`,
      {
        params,
      }
    );
  },

  getTravelForm(): AxiosPromise {
    return ApiService.get(
      `${this.url}/travel-insurances/quotation-forms/${formConfigVersionSegment(
        formConfigVersions.travelQuotation
      )}`
    );
  },

  getTravelOfferFormConfig(): AxiosPromise<OfferFormConfigInterface> {
    return ApiService.get(
      `${this.url}/travel-insurances/offer-forms/${formConfigVersionSegment(
        formConfigVersions.travelOffer
      )}`
    );
  },

  getTravelOfferFormConfigForPoland(): AxiosPromise<OfferFormConfigInterface> {
    return ApiService.get(
      `${
        this.url
      }/travel-insurances/poland-offer-forms/${formConfigVersionSegment(
        formConfigVersions.travelPolandOffer
      )}`
    );
  },

  getTravelCheckoutFormConfig(
    insurer: string,
    resultId: string
  ): AxiosPromise<FormConfig> {
    const params = {
      insurer,
      resultId,
    };

    return ApiService.get(
      `${this.url}/travel-insurances/checkout-forms/${formConfigVersionSegment(
        formConfigVersions.travelCheckout
      )}`,
      {
        params,
      }
    );
  },

  getTravelPaymentFormConfig(
    insurer: string,
    resultId: string,
    offerId: string
  ): AxiosPromise<FormConfig> {
    const params = {
      insurer,
      resultId,
      offerId,
    };

    return ApiService.get(
      `${this.url}/travel-insurances/payment-forms/${formConfigVersionSegment(
        formConfigVersions.travelPayment
      )}`,
      {
        params,
      }
    );
  },
};
